
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/leaderboards/[slug]",
      function () {
        return require("private-next-pages/events/leaderboards/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/leaderboards/[slug]"])
      });
    }
  